import React from "react";
import TexteKategorie from "./TexteKategorie";

const Texte = ({ texteData }) => (
  <section id="texte" className="content">
    <h2>Texte</h2>
    {texteData.map((kategorie, index) => (
      <TexteKategorie
        kategorieData={kategorie}
        index={index}
        key={kategorie.id}
      />
    ))}
  </section>
);

export default Texte;